import React, { useRef } from 'react';
import { analytics } from '@sendgrid/bloodhound';
import PropTypes from 'prop-types';
import Styles from './multisidebar.module.scss';
import { MultiProductCard } from './MultiProductCard';
import { TotalCard } from './TotalCard';
import { AddOnCard } from './AddOnCard';
import { ENVIRONMENT } from '../../constants';
import getEnvVariable from '../../utils/environment';
import { YourProductsEvents } from '../../analytics/yourProductsEvents';
import SignupConfidenceVariation1 from '../SignupConfidence/signupConfidenceVariation1';
import SignupConfidenceVariation2 from '../SignupConfidence/signupConfidenceVariation2';
import {
  signupConfidenceVariation1Id,
  signupConfidenceVariation2Id,
} from '../../experiments/signupConfidence/experiment';

const pricingLink = `${getEnvVariable(ENVIRONMENT.SG_WEBSITE_URL)}/pricing/`;

export const MultiSideBar = ({ activePackage, addOns, experimentVariation }) => {
  const pricingLinkRef = useRef();
  if (pricingLinkRef.current) {
    analytics.trackLink({
      ...YourProductsEvents.pricingLinkClicked(),
      element: pricingLinkRef.current,
    });
  }

  const showVariation1 = experimentVariation === signupConfidenceVariation1Id;
  const showVariation2 = experimentVariation === signupConfidenceVariation2Id;
  const showOriginal = !showVariation1 && !showVariation2;

  return (
    <aside className={Styles.sidenav}>
      <section className={Styles.sidenavContainer}>
        {showVariation1 && <SignupConfidenceVariation1 />}
        {showVariation2 && <SignupConfidenceVariation2 />}
        {showOriginal && (activePackage && activePackage.length > 0)
          && (
          <div>
            <div>
              <h2>Your Products</h2>
            </div>
            {activePackage.map(product => (
              <MultiProductCard
                key={product.id}
                product={product}
              />
            ))}
            {(addOns.ip > 0 || addOns.ease > 3)
            && (
            <AddOnCard
              addOns={addOns}
            />
            )
            }
            <TotalCard
              activePackage={activePackage}
              addOns={addOns}
            />
          </div>
          )
        }
        {showOriginal && (!activePackage || activePackage.length === 0)
          && (
          <div className={Styles.noProductCard}>
            Sign up for your free SendGrid account and get instant access to our
            <strong> Email API</strong>
            {' '}
  and
            <strong>Marketing Campaigns </strong>
            products. If you’re interested in exploring our paid plans, check out our
            <a href={pricingLink} ref={pricingLinkRef}> plans and pricing</a>
  .
          </div>
          )
        }
      </section>
    </aside>
  );
};

MultiSideBar.defaultProps = {
  experimentVariation: null,
};

MultiSideBar.propTypes = {
  addOns: PropTypes.shape({
    ease: PropTypes.number,
    ip: PropTypes.number,
  }).isRequired,
  activePackage: PropTypes.arrayOf(PropTypes.shape({
    adjusted_price: PropTypes.number,
    base_price: PropTypes.number,
    description: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  experimentVariation: PropTypes.string,
};

export default MultiSideBar;
